module.exports = __webpack_public_path__ + "img/mail.a2869131.svg";